export const generateRandomNumber = (max: number, min: number) =>
  Math.random() * (max - min) + min;
